/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Typ výsledku fulltextového vyhledávání
 * @export
 * @enum {string}
 */

export const EnumRightsFulltextSearchResult = {
    PRACOVNIK: 'PRACOVNIK',
    ORG_JEDNOTKA: 'ORG_JEDNOTKA',
    ORG_ROLE: 'ORG_ROLE'
} as const;

export type EnumRightsFulltextSearchResult = typeof EnumRightsFulltextSearchResult[keyof typeof EnumRightsFulltextSearchResult];



